import store from '@/store'
import { createRouter, createWebHistory } from 'vue-router'
import gh from '@/helpers/gh'

const routerHistory = createWebHistory()
const router = createRouter({
    history: routerHistory,
    routes: [], //defined globally in main
    scrollBehavior () {
        //scroll to top on all page changes
        return { top: 0 }
    }
})

router.beforeEach((to, from, next) => {
    //first page load
    if (window.config.routerInTransition) {
        next(false)
        return false
    } else {
        window.config.routerInTransition = true
        if (window.config.loadedOnce === false) {
            window.config.loadedOnce = true
            store.commit('routerNext', next)
            setTimeout(function () {
                store.commit('triggerTransitionOverlay', true)
            }, 500)
        } else {
            store.commit('routerNext', next)
            store.commit('triggerTransitionOverlay', true)
        }
        store.commit('setMobileNavOpen', false)
    }
})

router.afterEach((to) => {
    // Remove any inline overflow style from the body
    document.body.style.removeProperty('overflow')

    // Set new title after gate
    let metaTitle = to.meta.title
    metaTitle += (metaTitle) ? ' - ' + window.config.metaTitleAddon : window.config.metaTitleAddon
    document.title = metaTitle

    gh.aosRefresh()

    window.scrollTo(0, 0)
    setTimeout(() => {
        window.scrollTo(0, 0)
    }, 150)
})

export default router
